export type StaticDataKeyLabelItem = {
  key: string;
  label?: string;
  index?: number;
}

export type ApplicationStaticDataResponseType = {
  industry?: StaticDataKeyLabelItem[];
  jobTitle?: StaticDataKeyLabelItem[];
  nationalities?: StaticDataKeyLabelItem[];
  propertyTypes?: StaticDataKeyLabelItem[];
  countries?: StaticDataKeyLabelItem[];
}

export type StaticDataType = Record<string, string>;

const staticDataModel = {
  state: {} as Record<string, StaticDataType>,
  reducers: {
    UPDATE(state: Record<string, StaticDataType>, data: StaticDataType, id: string): Record<string, StaticDataType> {
      return {
        ...state,
        [id]: {
          ...state[id],
          ...data,
        },
      };
    },
  },
};

export default staticDataModel;
